module.exports = __webpack_public_path__ + "static/media/FOBIA.276f050b.png";